import { OkrObjectiveComment } from "server/models"

export interface OkrObjectiveCommentList { [objectiveId: number]: OkrObjectiveComment[] }

export type OkrObjectiveCommentValidation = { [key in keyof OkrObjectiveComment]?: string}

export interface OkrObjectiveCommentState {
    commentList: OkrObjectiveCommentList
}

export const OKR_OBJECTIVE_COMMENT_LIST = "OKR_OBJECTIVE_COMMENT_LIST"
